/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:49
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-11-03 14:16:54
 */
import { remove } from 'lodash';

export function treeToArray(tree) {
  const arr: Array<any> = [];
  const loop = (data) => {
    data.forEach((k: any) => {
      if (k?.children?.length) {
        arr.push(k);
        loop(k.children);
      } else {
        arr.push(k);
      }
    });
  };
  loop(tree);
  return arr;
}

/**
 * 判断子数组的值是否都在父数组中
 * @export
 * @param {*} pArr
 * @param {*} cArr
 * @returns
 */
export function includeArr(pArr, cArr) {
  return cArr.every((item) => pArr.includes(item));
}

export function addArr(arr, item) {
  if (arr.includes(item)) {
    return;
  }

  arr.push(item);
}

export function editArr(pArr, key, checked) {
  if (checked) {
    addArr(pArr, key);
  } else {
    remove(pArr, (item) => item === key);
  }
}

export function includesStr(str1, str2) {
  return str1?.toUpperCase().includes(str2?.toUpperCase());
}
